export const sharp = (
  <svg

    viewBox="0 0 13 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.288 4.40908V2.28787L10.1667 2.92423V0.166656H8.04553V3.56059L5.92432 4.19696V1.22726H3.80311V4.83332L1.6819 5.46968V7.59089L3.80311 6.95453V9.07574L1.6819 9.7121V11.8333L3.80311 11.197V13.9545H5.92432V10.5606L8.04553 9.92422V12.8939H10.1667V9.28786L12.288 8.6515V6.53029L10.1667 7.16665V5.04544L12.288 4.40908ZM8.04553 7.80301L5.92432 8.43938V6.31817L8.04553 5.6818V7.80301Z"
      fill="#715450"
    />
  </svg>
);
